import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import { ContextMenu } from './context-menu/ContextMenu';
import styles from './TopBar.module.scss';
import { useMatch } from 'react-router-dom';
import { Search, SearchSize } from '@sanlam-glacier/app-common/components';
import { useConfig } from 'providers/config/ConfigProvider';

export const TopBar = () => {
  const { theme } = useConfig();
  const { brandLogo, glacierLogo } = useGetBranding(theme);
  const isDashboard = useMatch('/dashboard');
  const isClientDashboard = useMatch('/clients/:userId');

  return (
    <div className={styles.topBar}>
      <div className={styles.logoContainer}>
        <img alt='Sanlam Glacier' className={styles.topBarIcon} src={glacierLogo} />
        {brandLogo && (
          <>
            <div className={styles.logoDivider} />
            <img alt='AF' className={styles.brandLogo} src={brandLogo} />
          </>
        )}
      </div>
      {(isDashboard || isClientDashboard) && (
        <div>
          <Search
            placeholder='Search by client name or ID...'
            size={SearchSize.SMALL}
            className={styles.clientSearchBar}
          />
        </div>
      )}

      <div style={{ display: 'flex', gap: '32px', height: '100%', alignItems: 'center' }}>
        <div className={styles.userInfoSection}>
          <ContextMenu />
        </div>
      </div>
    </div>
  );
};
